import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  body {
    background: ${({ theme }) => theme.body} !important;
    transition: all 0.50s linear;
   }

  .bg-gradient-ucla {
    background: ${({ theme }) => theme.nav} !important;
   }
   
  .color-ucla {
       color: ${({ theme }) => theme.heading};
   }

   .color-primary {
    color: ${({ theme }) => theme.colorPrimary};
    }

  .ht-content {
    background: ${({ theme }) => theme.cardBody} !important;
  }

  /* Pills in HomeTabs */
  .ht-pill {
    color: ${({ theme }) => theme.toggleButton} !important;
    border: 1px solid ${({ theme }) => (theme.body === '#ffffff' ? '#ccc' : theme.toggleBorder)} !important;
    background: ${({ theme }) => (theme.body === '#ffffff' ? '#ffffff' : 'transparent')} !important;
  }

  .ht-pill.is-active {
    background: #005687 !important;
    border-color: #005687 !important;
    color: #ffffff !important;
  }

  /* Methodology Rich Text styling for both light and dark modes */
  #qull-methodology,
  #qull-methodology .ql-container,
  #qull-methodology .ql-editor {
    color: ${({ theme }) => theme.text} !important;
    background: transparent !important;
  }

  #qull-methodology .ql-editor p,
  #qull-methodology .ql-editor .ql-align-center,
  #qull-methodology .ql-editor span,
  #qull-methodology .ql-editor li,
  #qull-methodology .ql-editor div {
    color: ${({ theme }) => theme.text} !important;
  }

  #qull-methodology .ql-editor h1,
  #qull-methodology .ql-editor h2,
  #qull-methodology .ql-editor h3,
  #qull-methodology .ql-editor h4,
  #qull-methodology .ql-editor h5,
  #qull-methodology .ql-editor h6 {
    color: ${({ theme }) => theme.headerColor} !important;
  }

  #qull-methodology .ql-editor .katex,
  #qull-methodology .ql-editor .katex * {
    color: ${({ theme }) => theme.equation} !important;
  }

   p {
   color:${({ theme }) => theme.text} !important;
   
  }
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    span {
       color:${({ theme }) => theme.headerColor} !important;
   
  }
  .equation {
    color:${({ theme }) => theme.equation} !important; 
   }

  .ht-card {
     background:${({ theme }) => theme.body} !important;
     color:${({ theme }) => theme.text} !important;
  }
  
  .ht-subCard {
     background:${({ theme }) => theme.body} !important;
     color:${({ theme }) => theme.text} !important;
  }

  .custom-tooltip {
     background:${({ theme }) => theme.body} !important;
     color:${({ theme }) => theme.text} !important;
  }

  .ht-card:not(.is-active) .ht-title,
  .ht-subCard:not(.is-active) .ht-subTitle {
      color:${({ theme }) => theme.listColor} !important; 
  }
  
   table {
     color:${({ theme }) => theme.table} !important;
     background: transparent !important;
    border-color: 1px solid #dee2e6 !important
   }

   .table thead th{
     border: 1px solid #dee2e6 !important;
     color:${({ theme }) => theme.text} !important;
   } 

   .table-striped>tbody>tr:nth-of-type(odd)>*{
     color:${({ theme }) => theme.text} !important;
   }
 
     table thead {
      background:${({ theme }) => theme.tableHeading} !important;
    }
    .stats-table > thead > tr > th {
       ${"" /* color:${({ theme }) => theme.colorTh} !important; */}
    }
    .forecasts-table tr:not(:first-child) span {
      color: ${({ theme }) => theme.colorTh} !important;
    }
    .table-striped > tbody > tr:nth-child(2n) > td,
    .table-striped > tbody > tr:nth-child(2n) > th {
      color:${({ theme }) => theme.colorTh} !important;
    } 

    .table-striped > tbody > tr:nth-of-type(odd) {
      background-color: ${({ theme }) => theme.colorThOdd} !important;
      color:${({ theme }) => theme.colorTh} !important;
    } 
    
   .footer{
     background:${({ theme }) => theme.footer} !important;
   }
   .slick-next:before,
   .slick-prev:before
    {
      color: ${({ theme }) => theme.arrowColor} !important;
    }
    .card-body{
    background:${({ theme }) => theme.cardBody} !important;
    }
    .card{
      background:${({ theme }) => theme.card} !important;
    }
    .maeCurrencyName{
      color:${({ theme }) => theme.maeCurrencyName} !important;
    }
    .card-subtitle{
       color:${({ theme }) => theme.cardSub} !important;
    }
    .toggle-button-mae{
      color:${({ theme }) => theme.toggleButton} !important;
      border-color:${({ theme }) => theme.toggleButton} !important;
    }
   
    .tab-text{
     color: ${({ theme }) => theme.tabText};
   }
   span.recharts-legend-item-text {
     color:${({ theme }) => theme.colorTh} !important;
     font-size: 12px !important
   }

  `;
